const extensionFormatList = [
    { value: '', label: '' },
    { value: 'POPIN', label: 'Popin' },
    { value: 'TOASTER', label: 'Toaster' },
    { value: 'HEADERBAR', label: 'Header bar' },
    { value: 'INPAGE', label: 'In-page' },
];

export default extensionFormatList;